import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { TranslateService } from 'src/app/Services/translate.service';
import { Router } from '@angular/router';
import { UserProfileComponent } from '../../user-profile/user-profile.component';
import { MatDialog } from '@angular/material';
import { AdminchangePasswordComponent } from './../adminchange-password/adminchange-password.component'
@Component({
  selector: 'app-admin-header',
  templateUrl: './admin-header.component.html',
  styleUrls: ['./admin-header.component.css']
})
export class AdminHeaderComponent implements OnInit {
  selected = 'ENG';
  constructor(public _global: GlobalService,private translate: TranslateService,private router:Router, public dialog: MatDialog) { }

  openuserProfileDialog(): void {
    const dialogRef = this.dialog.open(UserProfileComponent, {
         panelClass: 'dialogPopclass',
         width: '495px'
     });
   }
 
  ngOnInit() {
  }
  logout(){
  //  alert("logout");
    sessionStorage.clear();
    this.router.navigate(["home"]);
  }
  onChange(eve) { 
    if (eve.value=="FRE") {
      this._global.pageDir = "ltr"
      this._global.selectLang = "fr";
      this._global.showArabic = true;
    } else {
      this._global.pageDir = "ltr"
      this._global.selectLang = "en";
      this._global.showArabic = false;
    }
    this.translate.use(this._global.selectLang).then((data) => {
      this._global.loadPageContent(window.location.href);
      this._global.menuContent = this.translate.data["menu"];
      this._global.commonContent = this.translate.data["commonmessage"];
      this._global.headerEmitter.emit("language change");
    });
  }



  openchangepassDialog(): void {

    sessionStorage.getItem('userName');
    const dialogRef = this.dialog.open(AdminchangePasswordComponent, {
      panelClass: 'dialogPopclass',
      width: '350px'
    });
  }
  
}
